module.exports = __webpack_public_path__ + "static/09-2f38bc821fa9e7e6e006450e1e308850.jpg";